import { Component } from 'global/interfaces/component.interface';
import ControllerBase from 'global/js/ControllerBase';
import { MoleculePaginationProps } from './m-pagination.data';
import { MoleculePaginationEvent, MyMoleculePaginationEvents } from './m-pagination.events';

const searchResultsPaginationTemplate = require('components/molecules/m-pagination/m-pagination.template.twig') as (
	data: Component<MoleculePaginationProps>
) => string;

export default class ControllerPagination extends ControllerBase {
	constructor(element: HTMLElement) {
		super(element);
		this.init();
	}

	private init(): void {
		const pages = this.$element.querySelectorAll<HTMLAnchorElement>('li.m-pagination__page a');

		pages.forEach((page) => {
			page.addEventListener('click', (event) => this.emitEvent(event));
		});
	}

	private emitEvent(event: MouseEvent | PointerEvent): void {
		event.preventDefault();

		const target = event.currentTarget as HTMLAnchorElement;

		const eventHref = target.getAttribute('href') || '';
		const eventPage = Number(target.dataset.page);

		this.dispatchCustomEvent<MoleculePaginationEvent>(
			MyMoleculePaginationEvents.pageEvent,
			{
				href: eventHref,
				page: eventPage
			},
			true,
			true,
		);
	}
}
